import React, { useCallback, useEffect, useState } from 'react'
import { plainToInstance } from 'class-transformer'

import { useDrawer } from '@hooks/contexts/DrawerContext/DrawerContext'
import { useGetRecommendationBooks } from '@hooks/category/useGetRecommendationBooks'
import { useAuthentication } from '@hooks/useAuthentication'
import { RecommendCatagoryType } from '@models/category/RecommendCatagoryType'
import { StoryDetailReaderType } from '@models/story/StoryDetailReaderType'
import {
  FormatType,
  RecommendedArticleAcceptProps,
  RecommendedArticleProps,
} from './interface'

export function withRecommendedArticle(
  Component: React.FC<RecommendedArticleProps>
) {
  function WithRecommendedArticle({
    categoryId,
    bookId,
    isEbook,
    bookType,
    isStoryPage = false,
    ...props
  }: RecommendedArticleAcceptProps) {
    const [format, setFormat] = useState<FormatType>({
      grid: [0, 1, 2, 3],
      col: 4,
    })
    const { isUserLoading } = useAuthentication()
    const {
      data: datas,
      isLoading,
      isLoadingToggleBookLike,
      handleLikeBook,
    } = useGetRecommendationBooks({
      categoryId,
      bookId,
      isEbook,
      bookType,
    })
    const storyDrawer = useDrawer({ drawer: 'story' })

    const showStoryDrawer = useCallback(
      (value: RecommendCatagoryType) => {
        storyDrawer.show({
          bookId: value.id,
          initialData: plainToInstance(StoryDetailReaderType, {
            id: value.id,
            coverImgPath: value.coverImgPath,
            title: value.title,
            writingType: value.writingType,
            publishedAt: value.publishedAt,
            cover: value.cover,
            viewCount: value.viewCount,
            commentCount: value.commentCount,
            likeCount: value.likeCount,
            publishedChapterCount: value.chapterCount,
            penName: value.penName,
            category: value.category,
            bookType: value.bookType,
            tags: value.tags,
            rating: value.rating,
            isTranslated: value.isTranslated,
            isEnded: value.isEnded,
            isEpub: value.isEpub,
            isPdf: value.isPdf,
            isLiked: value.isLiked,
          }),
        })
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    )

    useEffect(() => {
      if (isStoryPage) {
        const col = /Android|iPhone/i.test(navigator.userAgent) ? 2 : 4
        setFormat({
          grid: Array.from({ length: col }).map((_, index) => index),
          col,
        })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const newProps = {
      ...props,
      datas,
      isLoading: isLoading || isUserLoading,
      isLoadingToggleBookLike,
      format,
      categoryId,
      bookType,
      isEbook,
      is1Row: datas ? datas.length <= 2 : false,
      handleLikeBook,
      showStoryDrawer,
    }
    return <Component {...newProps} />
  }

  return WithRecommendedArticle
}
